/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_DescriptionInputs */

const es_admin_company_overview_description = /** @type {(inputs: Admin_Company_Overview_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen del estado de tu cuenta, plan actual y uso de mensajes.`)
};

const en_admin_company_overview_description = /** @type {(inputs: Admin_Company_Overview_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview of your account status, current plan, and message usage.`)
};

/**
* | output |
* | --- |
* | "Overview of your account status, current plan, and message usage." |
*
* @param {Admin_Company_Overview_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_description = /** @type {((inputs?: Admin_Company_Overview_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_description(inputs)
	return en_admin_company_overview_description(inputs)
});
export { admin_company_overview_description as "admin.company_overview.description" }